import { itemCodeText, verifiedGroupDimensions } from "../lib/catalogueDetails";

export default function CatalogueDetails({ product, dimensions = false, className = "" }) {
  const codes = itemCodeText(product);
  const suppliedDimensions = verifiedGroupDimensions(product);
  return (
    <div className={"text-[11px] text-mocha leading-relaxed space-y-1 " + className}>
      {product.sku && <p>SKU: <span className="font-medium">{product.sku}</span></p>}
      {codes && <p>Item codes: {codes}</p>}
      {dimensions && suppliedDimensions && <div className="pt-3"><p className="font-medium">Catalogue group dimensions{product.dimension_unit === "in" ? " (inches)" : ""}</p><p className="whitespace-pre-line mt-1">{suppliedDimensions}</p><p className="mt-2">Dimensions supplied for this group; confirm specifications for each item code.</p></div>}
      {dimensions && product.dimension_mapping_pending === true && <p className="pt-2">Dimensions per item code to be confirmed</p>}
      {dimensions && product.specification_note && <p className="pt-2">{product.specification_note}</p>}
    </div>
  );
}
